export enum TooltipPosition {
	Above = "above",
	Below = "below",
}
